import { memo } from 'react';

import SaveIconSVG from '@/assets/save-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

const ISaveIcon = ({ className, ...rest }: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SaveIconSVG} className={merge('animate-spin', className)} {...rest} />
);

export const SaveIcon = memo(ISaveIcon) as typeof ISaveIcon;
